'use client';

import { useState, useEffect } from "react";
import styles from "./ContactForm.module.css";

export default function ContactForm({ name, isOpen, onClose }) {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    });

    useEffect(() => {
        const handleClickOutside = (event) => {
            const modal = document.getElementById("contactForm");
            if (isOpen && modal && !modal.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation simple
        if (!formData.firstName || !formData.lastName || !formData.email || !formData.message) {
            alert("Veuillez remplir tous les champs avant de soumettre.");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            alert("Veuillez entrer une adresse email valide.");
            return;
        }

        // ✅ Si tout est bon
        console.log("Formulaire soumis :");
        console.log("Prénom :", formData.firstName);
        console.log("Nom :", formData.lastName);
        console.log("Email :", formData.email);
        console.log("Message :", formData.message);

        // Réinitialiser et fermer la modale
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
        onClose();
    };

    return (
        <div className={styles.modalWrapper}>
            <div className={styles.modal} id="contactForm">
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    className={styles.closeButton}
                    onClick={onClose}
                    fill="white"
                >
                    <path d="M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z"/>
                </svg>
                <h1 className={styles.contactTitle}>Contactez-moi<br />{name}</h1>

                <form className={styles.form} onSubmit={handleSubmit}>
                    <label htmlFor="firstName">Prénom</label>
                    <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="lastName">Nom</label>
                    <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="message">Votre message</label>
                    <textarea
                        id="message"
                        name="message"
                        rows="8"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    ></textarea>

                    <button type="submit" className={styles.submitButton}>
                        Envoyer
                    </button>
                </form>
            </div>
        </div>
    );
}

function sendForm(firstName, lastName, email, message){
    console.log("Prénom : " + firstName);
    console.log("Nom : " + lastName);
    console.log("Email : " + email);
    console.log("Votre message : " + message);
}
